import { ReactNode } from 'react';
import { SerializedStyles } from '@emotion/react';
import { LocationFeatureFlagSettingName } from '@weave/schema-gen-ts/dist/schemas/payments/messages/location_settings/location_settings.pb';
import { InvoiceSummary as InvoiceSummaryModel } from '@frontend/api-invoices';
import { useTranslation } from '@frontend/i18n';
import { useLocationFeatureSettingsDirect } from '@frontend/payments-hooks';
import { SummaryItem } from '../../SummaryItem';
import { SummaryScrollContainer } from './summary-scroll-container';

export interface InvoiceSummaryCardProps {
  summary?: InvoiceSummaryModel;
  loading: boolean;
  style?: SerializedStyles;
  children?: ReactNode;
  locationIds: string[];
}

export type SummaryCardProps = Omit<InvoiceSummaryCardProps, 'style'> & {
  displayDateLabel?: string;
};

export const InvoiceSummaryCard = ({ summary, loading, style, locationIds }: InvoiceSummaryCardProps) => {
  const { t } = useTranslation('payments');
  const { enabledLocations: featureSettingEnabledLocations } = useLocationFeatureSettingsDirect(
    LocationFeatureFlagSettingName.SURCHARGING_ENABLED,
    { locationIds }
  );
  return (
    <SummaryScrollContainer style={style}>
      <SummaryItem label={t('Total Processed')} amount={summary?.gross} loading={loading} />
      {featureSettingEnabledLocations.length > 0 && (
        <>
          <SummaryItem label={t('Total Surcharge')} amount={summary?.totalSurchargeAmount ?? 0} loading={loading} />
          <SummaryItem
            label={t('Total Paid')}
            amount={(summary?.totalSurchargeAmount ?? 0) + (summary?.gross ?? 0)}
            loading={loading}
          />
        </>
      )}

      <SummaryItem label={t('Total Refunded')} amount={summary?.refunds} loading={loading} />
      <SummaryItem label={t('Total Fees')} amount={summary?.fees} loading={loading} />
      <SummaryItem
        label={t('Total Net Revenue')}
        amount={(summary?.net || 0) + (summary?.totalSurchargeAmount || 0)}
        loading={loading}
      />
    </SummaryScrollContainer>
  );
};
